import { createStore } from 'vuex'

export default createStore({
    state: {
        aid: '64ec0ef2d1de540057bb44f8', // 活动id
        musicPaused: false,// 音乐播放状态
        userInfo: {}, // 用户信息
        dialogData: null, // 弹框数据
        activityData: null, // 活动数据
        shareData: {}, // 分享信息
        topicData: {},
        page: 'Home',
        ruleShow: false,
        lineShow: false,
        shareImgData: null,
        messageData: null,
        isCreating: false
    },
    mutations: {
        SET_AID (state, aid: string) {
            state.aid = aid
        },
        SET_MUSICPAUSED (state, flag: boolean) {
            state.musicPaused = flag
        },
        SET_USERINFO (state, data) {
            state.userInfo = data
        },
        SET_DIALOGDATA (state, data) {
            state.dialogData = data
        },
        SET_SHAREDATA (state, data) {
            state.shareData = data
        },
        SET_ACTIVITYDATA (state, data) {
            state.activityData = data
        },
        SET_TOPICDATA (state, data) {
            state.topicData = data
        },
        SET_PAGE (state, page) {
            state.page = page
        },
        SET_RULESHOW (state, data) {
            state.ruleShow = data
        },
        SET_LINESHOW (state, data) {
            state.lineShow = data
        },
        SET_SHAREIMGDATA (state, data) {
            state.shareImgData = data
        },
        SET_MESSAGEDATA (state, data) {
            state.messageData = data
        },
        SET_ISCREATING (state, data) {
            state.isCreating = data
        }
    },
    actions: {
    },
    modules: {
    }
})
